export default __webpack_public_path__ + "static/media/gogo.2a922660.png";